<template>
  <v-card flat border class="ma-4">
    <v-card-title>
      {{ $t("users.settings.menuItems.profile") }}
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field
            :label="$t('users.itemAttributes.email')"
            :model-value="user.email"
            variant="underlined"
            prepend-icon="mdi-email"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field
            :label="$t('users.details.name')"
            :model-value="userName"
            variant="underlined"
            prepend-icon="mdi-account"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row v-if="user.description">
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field
            :label="$t('users.itemAttributes.description')"
            :model-value="user.description"
            variant="underlined"
            prepend-icon="mdi-text-box-outline"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field
            :label="$t('users.itemAttributes.role')"
            :model-value="loggedInUser.roleName"
            variant="underlined"
            prepend-icon="mdi-shield-account"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field
            :label="$t('users.itemAttributes.webshopRole')"
            :model-value="webshopRole"
            variant="underlined"
            prepend-icon="mdi-cart"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field
            :label="$t('users.itemAttributes.tenant')"
            :model-value="tenantName"
            variant="underlined"
            prepend-icon="mdi-domain"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-text-field
            :label="$t('users.itemAttributes.lastLogin')"
            :model-value="lastLoginFormatted"
            variant="underlined"
            prepend-icon="mdi-clock-outline"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions class="px-4">
      <v-btn @click.stop="showChangePasswordDialog = true">
        <v-icon class="mr-2">mdi-lock-reset</v-icon>
        {{ $t("login.changePassword") }}...
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn @click.stop="onSignOut">
        <v-icon class="mr-2">mdi-logout</v-icon>
        {{ $t("login.signOut") }}
      </v-btn>
    </v-card-actions>

    <v-divider></v-divider>
    <v-card-actions class="justify-center py-3">
      <v-btn
        size="small"
        variant="text"
        color="grey-darken-1"
        class="text-none"
        href="https://www.brokk.com/privacy-policy/"
        target="_blank"
      >
        {{ $t("termsOfService.privacyPolicy") }}
        <v-icon size="x-small" class="ml-2">mdi-open-in-new</v-icon>
      </v-btn>
      <v-divider vertical class="mx-2 my-3"></v-divider>
      <v-btn
        size="small"
        variant="text"
        color="grey-darken-1"
        class="text-none"
        href="/docs/terms-of-service.html"
        target="_blank"
      >
        {{ $t("termsOfService.title") }}
        <v-icon size="x-small" class="ml-2">mdi-open-in-new</v-icon>
      </v-btn>
    </v-card-actions>

    <ChangePasswordDialog v-model="showChangePasswordDialog" />
  </v-card>
</template>

<script>
import ChangePasswordDialog from "@/dialogs/ChangePasswordDialog"

export default {
  components: {
    ChangePasswordDialog
  },
  data() {
    return {
      user: {},
      showChangePasswordDialog: false
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.fetchUserDetails()
  },
  computed: {
    loggedInUser() {
      return this.$store.getters.loggedInUser
    },
    userName() {
      const first = this.user.firstName || ""
      const last = this.user.lastName || ""
      return `${first} ${last}`.trim()
    },
    tenantName() {
      return this.$store.getters.tenantRoot?.name || ""
    },
    webshopRole() {
      if (this.loggedInUser.webshopRole !== undefined) {
        return this.loggedInUser.webshopRole
      }
      const access = this.$store.getters.getWebshopAccess(this.loggedInUser)
      if (!access || access.localeCompare("none") === 0) {
        return "-"
      }
      return access
    },
    lastLoginFormatted() {
      if (!this.loggedInUser.auth_time) {
        return ""
      }
      const lastLogin = new Date(1000 * this.loggedInUser.auth_time)
      return this.$filters.localeDateFilter(lastLogin)
    }
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    fetchData() {
      if (this.$route.query.change_password === null) {
        this.showChangePasswordDialog = true
      }
    },
    async fetchUserDetails() {
      await this.$store.dispatch("fetchUserDetails", {
        tenantUid: this.loggedInUser.tenantUid,
        uid: this.loggedInUser.uid
      })
      const res = this.$store.getters.userDetails

      if (res != null) {
        this.user = res
      }
    },
    onSignOut() {
      this.$store.dispatch("logout")
    }
  }
}
</script>

<style></style>
